import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// import JS files

// import others files
import bullletIcon from "../../../assets/imgs/red-bullet.svg";
import { useNavigate } from "react-router-dom";

const Header = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <div
          className={
            props.smallSize
              ? "flex justify-between items-center"
              : "flex justify-between items-center text-xl"
          }
        >
          <img
            src={bullletIcon}
            className={
              props.smallSize
                ? " self-start mt-[0.5rem] ml-2"
                : " self-start mt-[0.65rem] ml-2"
            }
          />
          <span
            className={
              props.whiteColor
                ? "text-white  font-bold "
                : "text-myblacks-400 font-bold "
            }
          >
            {props.header}
          </span>
        </div>
        {props.noAllItems ? (
          ""
        ) : (
          <div
            onClick={
              props.redirect_url !== undefined
                ? () => navigate(props.redirect_url)
                : undefined
            }
            className="flex items-center text-sm text-myreds-100 cursor-pointer transition-all hover:scale-105"
          >
            <span>مشاهده همه</span>
            <ArrowBackIosIcon fontSize="1rem" />
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
